import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      d: "M10 .5c3.864 0 7 3.134 7 7 0 .724-.063 1.293-.232 1.866-.171.577-.458 1.183-.933 1.972-.963 1.6-2.622 3.835-5.476 7.973A.43.43 0 0 1 10 19.5a.422.422 0 0 1-.356-.184l-.002-.002c-2.855-4.139-4.515-6.375-5.477-7.975-.475-.79-.762-1.395-.933-1.972C3.062 8.794 3 8.225 3 7.5a7 7 0 0 1 7-7Zm0 .25A6.757 6.757 0 0 0 3.25 7.5c0 .645.051 1.199.229 1.791.175.587.467 1.186.917 1.932.889 1.473 2.471 3.639 5.193 7.573l.411.595.411-.595c2.732-3.948 4.315-6.106 5.201-7.572.449-.742.74-1.337.913-1.924.176-.592.225-1.149.225-1.8A6.757 6.757 0 0 0 10 .75Zm0 4.09a2.625 2.625 0 1 1 0 5.25 2.625 2.625 0 0 1 0-5.25Zm0 .25a2.376 2.376 0 0 0 0 4.75 2.376 2.376 0 0 0 0-4.75Z"
    }, null, -1)
  ])))
}
export default { render: render }